import { get, writable } from "svelte/store";
import InputHelper from "../Helpers/InputHelper";
import roundFloat from "../Helpers/Misc/roundFloat";

class BoxSelect {
	constructor() {
		this.start = writable({ lng: 0, lat: 0 });
		this.end = writable({ lng: 0, lat: 0 });
		this.cursor = {
			start: writable(null)
		};
		this.dragging = writable(false);
		this.roundTo = writable(-1);

		this.map = null;
		this.box = null;
	}

	mouseDown(map, event) {
		event.preventDefault(); // don't let it drag?
		this.map = map;
		this.start.set(event.lngLat);
		const useEvent = (InputHelper.isTouchScreen()) ? event.touches[0] : event.originalEvent;
		this.cursor.start.set(InputHelper.getMousePos(useEvent, this.map));
		this.dragging.set(true);
	}

	mouseUp(map, event) {
		event.preventDefault();
		this.map = map;

		this.end.set(event.lngLat);
		this.dragging.set(false);

		if (this.box) {
			this.box.parentNode.removeChild(this.box);
			this.box = null;
		}
		return true;
	}

	mouseMove(map, event) {
		this.map = map;

		if (get(this.dragging)) {
			event.preventDefault();

			const canvasContainer = this.map.getCanvasContainer();

			// Append the box element if it doesnt exist
			if (!this.box) {
				this.box = document.createElement("div");
				this.box.classList.add("boxSelectBox");
				canvasContainer.appendChild(this.box);
			}

			const start = get(this.cursor.start);
			const useEvent = (InputHelper.isTouchScreen()) ? event.touches[0] : event.originalEvent;
			const current = InputHelper.getMousePos(useEvent, this.map);

			const minX = Math.min(start.x, current.x);
			const maxX = Math.max(start.x, current.x);
			const minY = Math.min(start.y, current.y);
			const maxY = Math.max(start.y, current.y);

			// Adjust width and xy position of the box element ongoing
			const pos = "translate(" + minX + "px," + minY + "px)";
			this.box.style.transform = pos;
			this.box.style.WebkitTransform = pos;
			this.box.style.width = maxX - minX + "px";
			this.box.style.height = maxY - minY + "px";
		}
	}

	getBBoxPixels() {
		if (this.map === null) {
			return false;
		}
		// const map = MapStore.helpers.getMap();
		const start = get(this.start);
		const startp = this.map.project(start);
		const end = get(this.end);
		const endp = this.map.project(end);
		const places = get(this.roundTo);
		if (places !== -1) {
			startp.x = roundFloat(startp.x, places);
			startp.y = roundFloat(startp.y, places);
			endp.x = roundFloat(endp.x, places);
			endp.y = roundFloat(endp.y, places);
		}
		return [[startp.x, startp.y], [endp.x, endp.y]];
	}

	getBBox() {
		const start = get(this.start);
		const end = get(this.end);
		const places = get(this.roundTo);
		if (places !== -1) {
			start.lng = roundFloat(start.lng, places);
			start.lat = roundFloat(start.lat, places);
			end.lng = roundFloat(end.lng, places);
			end.lat = roundFloat(end.lat, places);
		}
		const minLng = Math.min(start.lng, end.lng);
		const minLat = Math.min(start.lat, end.lat);
		const maxLng = Math.max(start.lng, end.lng);
		const maxLat = Math.max(start.lat, end.lat);
		return [[minLng, minLat], [maxLng, maxLat]];
	}

	getExtent() {
		const bbox = this.getBBox();
		return [
			bbox[0][0],
			bbox[1][0],
			bbox[0][1],
			bbox[1][1]];
	}
}
export default BoxSelect;
